<template>
    <section class="section">
        <div class="columns">
            <div class="column is-2 menu-vert">
                <MenuVert :currentactive="'system-i18n'" />
            </div>
            <div class="column is-10" style="margin-top:25px;">
                <tr-title-bar
                    :translatedTrUnits="translatedTrUnits"
                    :totalTrUnits="totalTrUnits"
                    :totalTranslated="translatedTrUnits"
                    :t9n_tags="t9n_tags"
                    @move-tr="selectTr($event)"
                >
                    System Message Translation
                </tr-title-bar>
                <div>
                    <div>
                        <b-field label="Source Language" grouped>
                            <b-select placeholder="Select a language" v-model="source">
                                <option v-for="o in possibleSources" :key="o [0]" :value="o [0]"
                                >{{ o [1] }}</option>
                            </b-select>
                        </b-field>
                        <b-field label="Target Language" grouped>
                            <b-select placeholder="Select a language" v-model="target">
                                <option v-for="o in possibleTargets" :key="o [0]" :value="o [0]"
                                >{{ o [1] }}</option>
                            </b-select>
                        </b-field>
                    </div>
                    <div class="card">
                        <div v-for="(vtr, idx) in systemMessage" :key="idx">
                            <tr-text  v-bind="vtr.text"
                                        :tracker="tracker"
                                        @edit-tr="editTranslation"
                                        />
                            <tr-text  v-bind="vtr.desc" v-if="vtr.desc"
                                        :tracker="tracker"
                                        @edit-tr="editTranslation"
                                        />
                        </div>
                    </div>
                    <tr-edit
                        :trackerIdx="currentTrackerIdx"
                        :tid="currentTid"
                        :translatedTrUnits="translatedTrUnits"
                        :totalTrUnits="totalTrUnits"
                        :vartext="true"
                        @move-tr="selectTr($event)"
                        @close="closeTrEdit"
                    />
                    <b-loading :active.sync="loading"></b-loading>
                </div>
            </div>
        </div>
    </section>
</template>

<script>
import TranslationBaseView      from "@/views/TranslationBaseView"
import { mapState, mapGetters } from 'vuex'

function sortTrEntries (a, b) {
    if ( a.sortKey < b.sortKey ){
        return -1;
    }
    if ( a.sortKey > b.sortKey ){
        return 1;
    }
    return 0;
}

export default {
    name: "SystemView",
    extends: TranslationBaseView,
    data () {
        return {
            currentTrackerIdx: null,
            currentTid: null,
            tracker:    []
        }
    },
    computed: {
        ...mapState   ("translation", {
            languages     : state => state.languages,
            systemMessage : state => state.system,
            sourceLang    : state => state.sourceLang,
            targetLang    : state => state.targetLang,
            t9n_tags      :   state => state.t9n_tags,
            }),
        ...mapGetters ("translation", ["possibleSources", "possibleTargets"]),
        loading () { return this.systemMessage.length == 0},
        source : {
            get () { return this.sourceLang},
            set (val) {
                this.$store.commit ("translation/changeSourceLang", val)
            }
        },
        target : {
            get () { return this.targetLang},
            set (val) {
                this.$store.commit ("translation/changeTargetLang", val)
            }
        },
        targetTr () {
            return this.languages [this.targetLang] [1]
        },
        surceTr () {
            return this.languages [this.sourceLang] [1]
        },
        vartextUntranslated () {
            let result = []
            for (let e of this.systemMessage) {
                let added = false
                for (let key of ["text", "desc"]) {
                    if (!added && key in e) {
                        const tid = e [key].val [0] [0]
                        if (!(tid in this.targetTr)) {
                            result.push (e)
                            e.sortKey = this.surceTr [tid]
                            added     = true
                        }
                    }
                }
            }
            result.sort (sortTrEntries)
            return result
        },
        systemMessageTranslated () {
            let result = []
            for (let e of this.systemMessage) {
                let added = false
                for (let key of ["text", "desc"]) {
                    if (!added && key in e) {
                        const tid = e [key].val [0] [0]
                        if (tid in this.targetTr) {
                            result.push (e)
                            e.sortKey = this.targetTr [tid]
                            added = true
                        }
                    }
                }
            }
            result.sort (sortTrEntries)
            return result
        }
    },
    watch: {
        sourceLang () {
            this.$store.commit ("translation/clearSystem")
            this.$store.dispatch ("translation/loadSystem", {self: this})
        },
        targetLang () {
            this.$store.commit ("translation/clearSystem")
            this.$store.dispatch ("translation/loadSystem", {self: this})
        },
    },
    methods: {
        getTranslation (tid) {
            return tid in this.targetTr [tid]
        },
        _clearRoot () {
        },
        _updateRoot () {
        },
    },
    mounted () {
        this.$store.dispatch ("translation/loadSystem", {self: this})
    }
}
</script>

<style>

</style>